import { MENU_ITEMS } from 'enums'
import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'
import { noop } from 'lodash'
import { selectElementDisplayType } from 'selectors/useInterface'
import { DISPLAY_TYPE } from 'config/constants/ui'
import { selectBehaviourSettings } from '~/selectors/mainView'
import { BehaviourSettings } from '~/config/constants/editorSettings'


export const SourceMediaListHeader = React.forwardRef(
/**
 * @typedef {object} SourceMediaListHeaderProps
 * @property {function(HTMLElement | null): void} [setDrag]
 * @property {("Audio" | "Transitions" | "Images" | "Text" | "Media" | "ProjectMedia")} menuItem
 * @property {React.ReactNode} header
 * @property {boolean} [isDragging]
 * @property {boolean} [asDragContainer]
 * @param {SourceMediaListHeaderProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 */
  (props, ref) => {
    const { setDrag = noop, menuItem, header, isDragging = false, asDragContainer } = props
    const { sourceList: sourceListDisplayType } = useSelector(selectElementDisplayType)
    const settings = useSelector(selectBehaviourSettings)
    const isDraggable = settings[BehaviourSettings.allowTimelineAndMediaLayoutChange]
    return (
      <div
        className={cx('assets-list__header', {
          row: sourceListDisplayType !== DISPLAY_TYPE.MIN_WIDTH,
          'is-draggable': isDraggable,
          block: [ MENU_ITEMS.AUDIO ].includes(menuItem),
        })}
        ref={refData => {
          if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = refData
          }
          if (isDraggable) {
            setDrag(refData)
          }
        }}
        style={{
          opacity: isDragging && !asDragContainer ? 0 : 1,
          flexWrap: menuItem === MENU_ITEMS.IMAGES ? 'wrap' : 'initial',
        }}
      >
        {header}
      </div>
    )
  }
)
